var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFloppyDisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FloppyDisk"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.7188 7.49058V17.0625C17.7188 17.2365 17.6496 17.4035 17.5265 17.5265C17.4035 17.6496 17.2365 17.7188 17.0625 17.7188H3.9375C3.76345 17.7188 3.59653 17.6496 3.47346 17.5265C3.35039 17.4035 3.28125 17.2365 3.28125 17.0625V3.9375C3.28125 3.76345 3.35039 3.59653 3.47346 3.47346C3.59653 3.35039 3.76345 3.28125 3.9375 3.28125H13.5094C13.5956 3.28125 13.6809 3.29822 13.7606 3.3312C13.8402 3.36418 13.9125 3.41252 13.9735 3.47346L17.5265 7.02654C17.5875 7.08748 17.6358 7.15982 17.6688 7.23944C17.7018 7.31906 17.7188 7.4044 17.7188 7.49058Z",
    stroke: "#4679CC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.5005 15.0945C11.769 15.0945 12.7974 14.0661 12.7974 12.7976C12.7974 11.5291 11.769 10.5007 10.5005 10.5007C9.23196 10.5007 8.20361 11.5291 8.20361 12.7976C8.20361 14.0661 9.23196 15.0945 10.5005 15.0945Z",
    stroke: "#4679CC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.125 7.87573H7.875V3.28198",
    stroke: "#4679CC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloppyDisk);
export default __webpack_public_path__ + "static/media/floppy-disk.8e6464ea6a1d4cdd173fd39b91c1e172.svg";
export { ForwardRef as ReactComponent };